import PropTypes from 'prop-types';
import React from 'react';
import Card from 'components/Card';
import UserDetailsHeader from 'components/users/UserDetailsHeader';
import styles from './userDetailsCard.scss';
import UserType from 'types/user';

const UserDetailsCard = ({ user, children, ...props }) =>
  <Card key={user.id} className={styles.userDetailsCard}>
    <UserDetailsHeader user={user} {...props} />
    {children}
  </Card>;

UserDetailsCard.propTypes = {
  user: UserType.isRequired,
  children: PropTypes.node,
};

export default UserDetailsCard;



// WEBPACK FOOTER //
// ./client/app/shared/components/users/UserDetailsCard/index.jsx